module.exports = __webpack_public_path__ + "img/step1.885a2ad3.png";